//Core
import React from "react"

//Style
import style from "./style.module.scss"

const { Container, TextWrapper, Rules, Check, Bonus, Info } = style

const BonusHeader = ({ bonus = "100" }) => {
  return (
    <div className={Container}>
      <div className={TextWrapper}>
        <h2 className={Rules}>Зробіть покупки або зніміть готівку</h2>
        <h2 className={Check}>на суму чеку від 500 грн і отримайте</h2>
        <h1 className={Bonus}>{`бонус ${bonus} грн!`}</h1>
        <h3 className={Info}>Акція діє з 01 грудня 2019 по 31 січня 2020</h3>
      </div>
    </div>
  )
}

export default BonusHeader
